var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.794 7.20053L12 4.85976L13.206 7.20053C13.4856 7.74334 14.1165 8.00467 14.6981 7.81859L17.206 7.01616L16.4036 9.52408C16.2175 10.1057 16.4788 10.7365 17.0216 11.0162L19.3624 12.2222L17.0216 13.4281C16.4788 13.7078 16.2175 14.3387 16.4036 14.9203L17.206 17.4282L14.6981 16.6257C14.1165 16.4397 13.4856 16.701 13.206 17.2438L12 19.5846L10.794 17.2438C10.5144 16.701 9.88348 16.4397 9.30191 16.6257L6.79399 17.4282L7.59642 14.9203C7.7825 14.3387 7.52117 13.7078 6.97836 13.4281L4.63759 12.2222L6.97836 11.0162C7.52117 10.7365 7.7825 10.1057 7.59642 9.52408L6.79399 7.01616L9.30191 7.81859C9.88348 8.00467 10.5144 7.74334 10.794 7.20053ZM17.3539 6.55399L17.3538 6.55431L17.3539 6.55399ZM17.3539 17.8903C17.3538 17.8902 17.3538 17.8901 17.3538 17.89L17.3539 17.8903ZM6.33182 17.5761C6.33195 17.576 6.33207 17.576 6.3322 17.5759L6.33182 17.5761Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointedCircle);
export default __webpack_public_path__ + "static/media/pointed_circle.5bfc833048ba7553f5c30534b0cfed0c.svg";
export { ForwardRef as ReactComponent };